import { render } from "./Supplier_assignment.vue?vue&type=template&id=682d53ab&scoped=true"
import script from "./Supplier_assignment.vue?vue&type=script&lang=js"
export * from "./Supplier_assignment.vue?vue&type=script&lang=js"

import "./Supplier_assignment.vue?vue&type=style&index=0&id=682d53ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682d53ab"]])

export default __exports__